var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M4.25 0.9H21.75C23.324 0.9 24.6 2.17599 24.6 3.75V16.25C24.6 17.824 23.324 19.1 21.75 19.1H4.25C2.67599 19.1 1.4 17.824 1.4 16.25V3.75C1.4 2.17599 2.67599 0.9 4.25 0.9Z"}}),_c('path',{attrs:{"d":"M2.375 1.875L12.1808 9.9504C12.6533 10.3395 13.338 10.3292 13.7986 9.92621L23 1.875"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }